import { render, staticRenderFns } from "./payable-add-or-update.vue?vue&type=template&id=6f348fc6&scoped=true"
import script from "./payable-add-or-update.vue?vue&type=script&lang=js"
export * from "./payable-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./payable-add-or-update.vue?vue&type=style&index=0&id=6f348fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f348fc6",
  null
  
)

export default component.exports